import API from "@/services/api/api.service";
import { Consent } from "@/utils/models/consent.model";
import stateStore from "@/utils/store";
import { RouteLocationNormalized } from "vue-router";

export const userConsentsResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const pending = await checkUserConsents();
        console.log(pending);
        if(pending.length === 0) {
            return { name: 'Welcome' };
        } else {
            to.meta.consents = pending;
        }
    } catch (error) {
        console.error('USER_CONSENTS_RESOLVER_ERROR');
        return { name: 'Welcome' };
    }
}

export const checkUserConsents = async (): Promise<Consent[]> => {
    try {
        const res = await API.getUserConsents();
        const consents = (res.data.data ?? []) as Consent[];
        const pending = consents.filter((consent) => consent.current_version?.user_action !== 'accept');
        return pending;
    } catch (error) {
        throw Error('CHECK_USER_CONSENTS');
    }
}